"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Setup = exports.INPUTS = exports.ResponseMode = void 0;
const helpers_1 = require("../helpers");
const Display = __importStar(require("./DisplayPanel"));
var modes;
(function (modes) {
    modes[modes["o"] = 0] = "o";
    modes[modes["i"] = 1] = "i";
    modes[modes["t"] = 2] = "t";
    modes[modes["d"] = 3] = "d";
})(modes || (modes = {}));
;
var ResponseMode;
var INPUTS;
function Setup(selectors) {
    exports.INPUTS = INPUTS = (0, helpers_1.getDomInputNodes)(selectors);
    const nX = Display.nX;
    handleURLLoad();
    const pacer_mode_btn = document.getElementById("pacer_mode");
    pacer_mode_btn.onchange = (event) => {
        let key = event.target.value;
        let chars = key.split(''); // [pacing, sensing, sense response]
        // pacing
        switch (chars[0]) {
            case 'a':
                INPUTS["a_out"].disabled = false;
                INPUTS["v_out"].disabled = true;
                break;
            case 'v':
                INPUTS["v_out"].disabled = false;
                INPUTS["a_out"].disabled = true;
                break;
            case 'd':
                INPUTS["a_out"].disabled = false;
                INPUTS["v_out"].disabled = false;
                break;
            case 'o':
                INPUTS["a_out"].disabled = true;
                INPUTS["v_out"].disabled = true;
            default:
                break;
        }
        // sensing
        switch (chars[1]) {
            case 'a':
                INPUTS["a_sense"].disabled = false;
                INPUTS["v_sense"].disabled = true;
                break;
            case 'v':
                INPUTS["v_sense"].disabled = false;
                INPUTS["a_sense"].disabled = true;
                break;
            case 'd':
                INPUTS["a_sense"].disabled = false;
                INPUTS["v_sense"].disabled = false;
                break;
            case 'o':
                INPUTS["a_sense"].disabled = true;
                INPUTS["v_sense"].disabled = true;
            default:
                break;
        }
        // response
        exports.ResponseMode = ResponseMode = modes[chars[2]];
        nX.dispatchEvent(new Event('change')); // redraw graphs
    };
    pacer_mode_btn.dispatchEvent(new Event('change'));
}
exports.Setup = Setup;
function handleURLLoad() {
    // check URL for pacer params to preset pacer input values
    const setup_params = (0, helpers_1.findGetParameters)();
    setup_params.forEach((v, i) => {
        const key = decodeURI(v[0]).toString();
        const val = decodeURI(v[1]).toString();
        if (INPUTS[key]) {
            INPUTS[key].value = val;
        }
        ;
    });
}
